export default "__VITE_ASSET__8890709d__"